import { createApp } from 'vue'
import init from './i18n'
import App from './Suspenser.vue'
import router from './router'
import { createMetaManager, defaultConfig, resolveOption, useMeta, plugin as metaPlugin } from 'vue-meta'
import store from './store'
import './styles/style.scss'

const decisionMaker5000000 = resolveOption((prevValue, context) => {
  const { uid = 0 } = context.vm || {}
  if (!prevValue || prevValue < uid) {
    return uid
  }
})

const metaManager = createMetaManager({
  ...defaultConfig,
  esi: {
    group: true,
    namespaced: true,
    attributes: ['src', 'test', 'text']
  }
}, decisionMaker5000000)

useMeta(
  {
    og: {
      something: 'test'
    }
  },
  metaManager
)

const app = createApp(App)
init(app)

app.use(createMetaManager()).use(metaPlugin).use(store).use(router).mount('#app')

// 전역 변수
app.config.globalProperties.globalUrl = 'https://www.gomlab.com/gomlab_v2/ui/gommixmax/'
app.config.globalProperties.$module = module
app.config.globalProperties.cashingNum = '?v=2208231'
